module.exports = __webpack_public_path__ + "img/_ic_checkbox_on.fe12bf84.svg";